'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: ', ';\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 35px;\n  align-items: flex-start;\n\n  @media(min-width: ', ') {\n    display: block;\n    margin-bottom: 0px;\n  }\n'], ['\n  width: 100%;\n  display: ', ';\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 35px;\n  align-items: flex-start;\n\n  @media(min-width: ', ') {\n    display: block;\n    margin-bottom: 0px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-image: url(', ');\n  height: 150px;\n  width: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n'], ['\n  background-image: url(', ');\n  height: 150px;\n  width: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n\n'], ['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n  text-align: center;\n'], ['\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n  text-align: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  font-weight: 600;\n  margin-top: 10px;\n'], ['\n  font-size: ', ';\n  font-weight: 600;\n  margin-top: 10px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 10px 0 15px;\n\n  &:empty {\n    margin: 0 0 15px;\n  }\n'], ['\n  margin: 10px 0 15px;\n\n  &:empty {\n    margin: 0 0 15px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../../config.js');

var _Button = require('../../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _YellowLineSVG = require('../../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$collapse ? 'none' : 'flex';
}, _config.breakpoints.m);

Wrapper.displayName = 'Wrapper';

var Image = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.$imgSrc;
});

Image.displayName = 'Image';

var Overlay = _styledComponents2.default.div(_templateObject3);

Image.displayName = 'Image';

var ImageOverlayTitle = _styledComponents2.default.h3(_templateObject4, _config.colors.white, (0, _rem2.default)('28px', _config.typography.baseFontSize));

ImageOverlayTitle.displayName = 'ImageOverlayTitle';

var Title = _styledComponents2.default.h3(_templateObject5, (0, _rem2.default)('28px', _config.typography.baseFontSize));

Title.displayName = 'Title';

var Subtitle = _styledComponents2.default.p(_templateObject6);

Subtitle.displayName = 'Subtitle';

var NoCollapse = function NoCollapse(_ref) {
  var _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === undefined ? '' : _ref$imgSrc,
      title = _ref.title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === undefined ? '' : _ref$subtitle,
      _ref$links = _ref.links,
      links = _ref$links === undefined ? [] : _ref$links,
      buttonLabel = _ref.buttonLabel,
      buttonUrl = _ref.buttonUrl,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === undefined ? true : _ref$collapse;
  return _react2.default.createElement(
    Wrapper,
    {
      $collapse: collapse
    },
    imgSrc && _react2.default.createElement(
      Image,
      {
        $imgSrc: imgSrc
      },
      _react2.default.createElement(
        Overlay,
        null,
        _react2.default.createElement(
          ImageOverlayTitle,
          null,
          title
        )
      )
    ),
    !imgSrc && _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(_YellowLineSVG2.default, null),
      _react2.default.createElement(
        Title,
        null,
        title
      )
    ),
    _react2.default.createElement(
      Subtitle,
      null,
      subtitle
    ),
    !!links.length && _react2.default.createElement(
      Subtitle,
      null,
      links.map(function (link) {
        return _react2.default.createElement(
          _Link2.default,
          {
            key: link.Text,
            title: link.Title,
            href: link.Href
          },
          link.Text
        );
      })
    ),
    _react2.default.createElement(
      _Button2.default,
      {
        onClick: function onClick() {
          return window.location.assign(buttonUrl);
        }
      },
      buttonLabel
    )
  );
};

NoCollapse.propTypes = {
  imgSrc: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string,
  links: _propTypes2.default.arrayOf(Object),
  buttonLabel: _propTypes2.default.string.isRequired,
  buttonUrl: _propTypes2.default.string.isRequired,
  collapse: _propTypes2.default.bool
};

NoCollapse.displayName = 'NoCollapse';

exports.default = NoCollapse;
NoCollapse.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'NoCollapse',
  'props': {
    'imgSrc': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'subtitle': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'links': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': 'Object'
        }
      },
      'required': false,
      'description': ''
    },
    'collapse': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'buttonLabel': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'buttonUrl': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
};